import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import {
  allowPublishersToMaintainRoutePreferences,
  updateProject,
  settingsSetSettings,
} from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useChangeSettings = (
  options: UseMutationOptions<
    void,
    unknown,
    {
      categoryKey: string;
      settings: Record<string, unknown>;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: {
      categoryKey: string;
      settings: Record<string, unknown>;
    }) => {
      if (payload.categoryKey === 'project-settings') {
        await extractData(
          updateProject({
            body: payload.settings,
          })
        );
      } else if (payload.categoryKey === 'participation') {
        await extractData(
          allowPublishersToMaintainRoutePreferences({
            path: {
              enabled: Boolean(
                payload.settings.allowPublishersToMaintainRoutePreferences
              ),
            },
          })
        );
      } else {
        await extractData(
          settingsSetSettings({
            path: {
              categoryKey: payload.categoryKey,
            },
            body: payload.settings,
          })
        );
      }
    },
    mutationKey: ['settings'],
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['setting', variables.categoryKey],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
